// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f2407cc9","601":"d55165c7","847":"427dc7b0","887":"d6a4a3a9"}[chunkId] + ".chunk.js";
};